module.exports = __webpack_public_path__ + "static/media/management-consultancy.f8bbbe6c.svg";